import React from "react";
import NewsReportsList from "../../components/NewsReports/NewsReportsList";
import { ToastContainer } from "react-toastify";

const NewsReports = () => {
  return (
    <div className='constituency-section'>
      <ToastContainer />
      <div className='pageTitle flex items-center justify-between pr-5 heading-sec pl-4'>
        <h1 className='heading-text'>News Reports</h1>
      </div>
      <div className='constituency-map'>
        <NewsReportsList />
      </div>
    </div>
  );
};

export default NewsReports;
